module.exports = __webpack_public_path__ + "images/training-wheels-3217deaedfd22133387f32af5c3acdcd.png";